import { render, staticRenderFns } from "./QScoreCardStandingLHRequests.vue?vue&type=template&id=21a9f52d&scoped=true&"
import script from "./QScoreCardStandingLHRequests.vue?vue&type=script&lang=js&"
export * from "./QScoreCardStandingLHRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9f52d",
  null
  
)

export default component.exports